"use client";

import { useEffect } from "react";
import { Button } from "@/components/ui/button";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <main className="mx-auto flex min-h-full max-w-lg flex-col justify-center gap-4 px-6 py-24">
      <h1 className="text-2xl font-semibold tracking-tight">
        Не удалось открыть страницу
      </h1>
      <p className="text-muted-foreground">
        Попробуйте ещё раз. Если ошибка повторится, обновите страницу.
      </p>
      {error.digest ? (
        <p className="text-sm text-muted-foreground">Код: {error.digest}</p>
      ) : null}
      <Button className="h-11 w-fit px-4" onClick={() => reset()}>
        Попробовать снова
      </Button>
    </main>
  );
}
